import Vue from 'vue';
import { ServerTable } from 'vue-tables-2'

Vue.use(ServerTable, {}, false, 'bootstrap4')